
import { Component, mixins } from 'nuxt-property-decorator';
import { SpeakersBlockModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../../ContentBlockMixin';
import SpeakersBlockList from './SpeakersBlockList.vue';

@Component({
  components: {
    RawHtml,
    SpeakersBlockList,
  },
})
export default class SpeakersBlock extends mixins(ContentBlockMixin<SpeakersBlockModel>) {}
